import { TextInterface } from 'common/types/entities/TextInterface'
import { isFontContainBoldWeight } from 'common/utils/fontsUtils'

export function getTextFontProperties(entity: TextInterface) {
  const fontProperties = []

  if (entity.fontFamily) {
    fontProperties.push({
      fontFamily: entity.fontFamily,
      fontStyle: entity.fontStyle,
      fontWeight: entity.fontWeight,
    })
  }

  if (entity.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontStyle: entity.mobileFontStyle,
      fontWeight: entity.mobileFontWeight,
    })
  }
  if (
    entity.fontFamily &&
    (entity.rawContentState?.includes('"style":"BOLD"') ||
      entity.content?.includes('<strong>'))
  ) {
    fontProperties.push({
      fontFamily: entity.fontFamily,
      fontStyle: 'normal',
      fontWeight: '700',
    })
  }

  if (
    entity.fontFamily &&
    (entity.rawContentState?.includes('"style":"ITALIC"') ||
      entity.content?.includes('<em>'))
  ) {
    fontProperties.push({
      fontFamily: entity.fontFamily,
      fontStyle: 'italic',
      fontWeight: entity.fontWeight,
    })
  }

  return fontProperties
}

export function getTextFontVariants(
  entity: TextInterface,
  fallbackFontFamily?: string,
) {
  const fontProperties = []
  if (entity.fontFamily) {
    fontProperties.push({
      fontFamily: entity.fontFamily,
      fontStyle: entity.fontStyle,
      fontWeight: entity.fontWeight,
    })
  }

  if (entity.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontStyle: entity.mobileFontStyle,
      fontWeight: entity.mobileFontWeight,
    })
  }

  if (
    entity.content?.includes('<strong>') &&
    isFontContainBoldWeight(entity.fontFamily || fallbackFontFamily)
  ) {
    fontProperties.push({
      fontFamily: entity.fontFamily || fallbackFontFamily,
      fontStyle: 'normal',
      fontWeight: '700',
    })
  }

  if (entity.content?.includes('<em>')) {
    fontProperties.push({
      fontFamily: entity.fontFamily || fallbackFontFamily,
      fontStyle: 'italic',
      fontWeight: entity.fontWeight,
    })
  }

  if (
    ['<strong>', '<em>'].some(tag => entity.content?.includes(tag)) &&
    !entity.fontWeight
  ) {
    fontProperties.push({
      fontFamily: entity.fontFamily || fallbackFontFamily,
      fontStyle: 'normal',
      fontWeight: '400',
    })
  }

  return fontProperties
}
